var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreMobiIcon = function SvgMoreMobiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.955 14.59a2.455 2.455 0 1 1 0 4.91 2.455 2.455 0 0 1 0-4.91M16.5 14.59a2.454 2.454 0 1 1 0 4.91 2.454 2.454 0 0 1 0-4.91M23.045 14.59a2.454 2.454 0 1 1 0 4.91 2.454 2.454 0 0 1 0-4.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 29.857c7.377 0 13.357-5.98 13.357-13.357S23.877 3.143 16.5 3.143 3.143 9.123 3.143 16.5 9.123 29.857 16.5 29.857m0 3.143C25.613 33 33 25.613 33 16.5S25.613 0 16.5 0 0 7.387 0 16.5 7.387 33 16.5 33",
    clipRule: "evenodd"
  })));
};
export default SvgMoreMobiIcon;